import { REVISION } from 'three';

const version = /*@__PURE__*/parseInt( /*@__PURE__*/REVISION.replace(/\D+/g, ''));

export { version };
